import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import { Action } from 'redux-act';
import { put, takeEvery } from 'redux-saga/effects';

import { changePassword, ChangePasswordPayload, passwordChanged, passwordChangeFailed } from '../../actions/user/changePassword';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function* changePasswordSaga({ payload }: Action<ChangePasswordPayload>) {
  const token = yield getAuthenticationToken();
  const { oldPassword, newPassword } = payload;
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.changePassword, token, {
    oldPassword,
    newPassword,
  });
  if (!response.error && !response.errorType) {
    yield put(passwordChanged({}));
  } else {
    yield put(passwordChangeFailed({ errorType: response.errorType }));
  }
}

export default function* watchChangePasswordSaga() {
  yield takeEvery(changePassword, changePasswordSaga);
}
